import React, { FunctionComponent } from 'react';
import { Avatar, Badge, Menu, Icon } from 'antd';
import { NavLink } from 'react-router-dom';
import MenuAvatar from '../MenuAvatar';

const LoginBar: FunctionComponent = () => {
  return (
    <Menu
      mode="horizontal"
      theme="light"
      overflowedIndicator={<Icon style={{ fontSize: '20px' }} type="user" />}>
      <Menu.SubMenu
        title={
          <span>
            <Menu.Item>
              <NavLink to="/login">
                <Icon type="login" />
                Login
              </NavLink>
            </Menu.Item>
          </span>
        }
      />
    </Menu>
  );
};

export default LoginBar;
